module.exports = __webpack_public_path__ + "img/img-3.360922b5.png";